import { render, staticRenderFns } from "./addSiDong.vue?vue&type=template&id=6f6d7487&scoped=true&"
import script from "./addSiDong.vue?vue&type=script&lang=js&"
export * from "./addSiDong.vue?vue&type=script&lang=js&"
import style0 from "./addSiDong.vue?vue&type=style&index=0&id=6f6d7487&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6d7487",
  null
  
)

export default component.exports